import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import { ListItemButton } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { deleteNotifications } from "../api/notification";
import { TIME_OFF_PAGE_TYPE, TRADE_PAGE_TYPE } from "../util/constants";
import { format_LongMonth_Date_Year_Time } from "../util/dateTimeFormatter";
import { convertUTCIntegerFieldToStationTimeZoneLuxonDateTime } from "../util/timeZoneService";

const useStyles = makeStyles((theme) => ({
  iconParent: {
    position: "relative",
  },
  iconCentering: {
    position: "absolute",
    top: "50%",
    left: "30%",
    transform: "translate(-50%, -50%)",
  },
  tradeIcon: {
    fontSize: 40,
    borderRadius: "50%",
    color: "white",
    backgroundColor: theme.palette.primary.main,
    padding: "5px",
    marginTop: "3px",
  },
  timeOffIcon: {
    fontSize: 40,
    borderRadius: "50%",
    color: theme.palette.secondary.swaWhite,
    backgroundColor: theme.palette.primary.swaYellow,
    padding: "5px",
    marginTop: "3px",
  },
  clearButtonIcon: {
    marginRight: "-10px",
    color: "inherit",
  },
  textDetail: {
    marginLeft: "-8px",
  },
  timestampParent: {
    marginTop: "5px",
  },
  timestamp: {
    backgroundColor: theme.palette.secondary.swaGray2,
    borderRadius: "4px",
    padding: "5px",
    marginTop: "30px",
    whiteSpace: "nowrap",
  },
}));

const Notification = (props) => {
  const classes = useStyles();
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const openCorrespondingNotificationDialog = () => {
    props.onNotificationClick(props.notification);
    deleteNotification(props.notification.id);
  };

  const clearNotification = () => {
    deleteNotification(props.notification.id);
  };

  const deleteNotification = (notificationId) => {
    setIsDeleteLoading(true);
    deleteNotifications(props.loggedInUserData.eid, notificationId)
      .then((res) => res.json())
      .then((result) => {
        props.onDeleteNotificationClick(notificationId);
        setIsDeleteLoading(false);
      })
      .catch((err) => {
        console.error("error happened!", err);
        setIsDeleteLoading(false);
      });
  };

  const renderNotificationDetail = () => {
    switch (props.notification.type) {
      case TIME_OFF_PAGE_TYPE:
        return (
          <Grid container className="notification-text" onClick={(event) => openCorrespondingNotificationDialog(event)}>
            <Grid item xs={3} sm={2} className={classes.iconParent}>
              <WatchLaterIcon className={`${classes.timeOffIcon} ${classes.iconCentering}`} />
            </Grid>
            <Grid item xs={9} sm={10} className={classes.textDetail}>
              <div>
                <span className="bold-text">
                  {props.notification.firstName === "Admin"
                    ? props.notification.firstName
                    : props.notification.lastName + ", " + props.notification.firstName}
                </span>{" "}
                {props.notification.torStatus} {props.notification.timeOffRequestType} {props.notification.actionVerb}
              </div>
              <div className={classes.timestampParent}>
                <span className={classes.timestamp}>
                  {format_LongMonth_Date_Year_Time(
                    convertUTCIntegerFieldToStationTimeZoneLuxonDateTime(
                      props.notification.createdAt,
                      props.loggedInUserData.activeStation
                    )
                  )}
                </span>
              </div>
            </Grid>
          </Grid>
        );
      case TRADE_PAGE_TYPE:
      default:
        // Since all current Trade notifications in the system will NOT have a 'type' associated,
        // we need to ensure the default case is handled with Trade functionality.
        return (
          <Grid container className="notification-text" onClick={(event) => openCorrespondingNotificationDialog(event)}>
            <Grid item xs={3} sm={2} className={classes.iconParent}>
              <SwapHorizIcon className={`${classes.tradeIcon} ${classes.iconCentering}`} />
            </Grid>
            <Grid item xs={9} sm={10} className={classes.textDetail}>
              <div>
                <span className="bold-text">
                  {props.notification.firstName === "Admin"
                    ? props.notification.firstName
                    : props.notification.lastName + ", " + props.notification.firstName}
                </span>{" "}
                {props.notification.tradeStatus} {props.notification.tradeFormType} {props.notification.actionVerb}
              </div>
              <div className={classes.timestampParent}>
                <span className={classes.timestamp}>
                  {format_LongMonth_Date_Year_Time(
                    convertUTCIntegerFieldToStationTimeZoneLuxonDateTime(
                      props.notification.createdAt,
                      props.loggedInUserData.activeStation
                    )
                  )}
                </span>
              </div>
            </Grid>
          </Grid>
        );
    }
  };

  return (
    <div data-testid="notification-list-item">
      <ListItemButton className="notification-item">
        {renderNotificationDetail()}
        <span></span>
        <div item xs={1}>
          {isDeleteLoading ? (
            <IconButton
              className={classes.clearButtonIcon}
              aria-label="Menu"
              disabled
              size="large">
              <CircularProgress size={20} />
            </IconButton>
          ) : (
            <IconButton
              className={classes.clearButtonIcon}
              aria-label="Menu"
              onClick={clearNotification}
              size="large">
              <DeleteForeverIcon />
            </IconButton>
          )}
        </div>
      </ListItemButton>
    </div>
  );
};

Notification.propTypes = {
  loggedInUserData: PropTypes.object.isRequired,
  notification: PropTypes.object.isRequired,
  onNotificationClick: PropTypes.func.isRequired,
  onDeleteNotificationClick: PropTypes.func.isRequired,
};

export default Notification;
